import { useEffect, useRef } from 'react'
import { useFrame, useThree } from '@react-three/fiber'
import { Octree } from 'three/examples/jsm/math/Octree.js';
import * as THREE from 'three';

// Reference to a set of active KeyboardEvent.code entries
const useCodes = () => {
  const codes = useRef(new Set())
  useEffect(() => {
    const onKeyDown = (e) => codes.current.add(e.code)
    const onKeyUp = (e) => codes.current.delete(e.code)
    window.addEventListener('keydown', onKeyDown)
    window.addEventListener('keyup', onKeyUp)
    return () => {
      window.removeEventListener('keydown', onKeyDown)
      window.removeEventListener('keyup', onKeyUp)
    }
  }, [])
  return codes
}

const vec = new THREE.Vector3();

// Rotation logic from three/examples/jsm/controls/PointerLockControls.js
function WasdControls() {
    const { camera, raycaster, scene } = useThree();
    const code = useCodes();
    const velocity = new THREE.Vector3();

    const moveForward = (distance) => {
        vec.setFromMatrixColumn(camera.matrix, 0);
        vec.crossVectors(camera.up, vec);
        camera.position.addScaledVector(vec, distance);
    }
    const moveRight = (distance) => {
        vec.setFromMatrixColumn(camera.matrix, 0);
        camera.position.addScaledVector(vec, distance);
    }
    const moveJump = (distance) => {
        vec.set(0,1,0);
        // vec.crossVectors(camera.up, vec)
        camera.position.addScaledVector(vec, distance);
    }
    useFrame((_, delta) => {

        
        raycaster.ray.set(camera.position, new THREE.Vector3(0, -1, 0));


        const intersections = raycaster.intersectObjects( scene.getObjectByName('intersectables') ? scene.getObjectByName('intersectables').children : scene.children, true );

        const onObject = intersections.length > 0;

        
        velocity.x -= velocity.x * 10.0 * delta;
        velocity.z -= velocity.z * 10.0 * delta;
        velocity.y -= 50.0 * delta;

        const speed = 5;
        if (code.current.has('KeyW')) velocity.z -= 100.0 * delta;
        if (code.current.has('KeyA')) velocity.x += 100.0 * delta;
        if (code.current.has('KeyS')) velocity.z += 100.0 * delta;
        if (code.current.has('KeyD')) velocity.x -= 100.0 * delta;
        if (code.current.has('Space') && onObject && intersections[0].distance < 8.5) velocity.y += 400.0 * delta;
        // console.log(code.current)
        if(camera.position.y > 200) velocity.y += 51 * delta;

        
        moveRight( - velocity.x * speed * delta );
        moveForward( - velocity.z * speed * delta );

        if ( onObject && intersections[0].distance < 8 && velocity.y < 0) {
          moveJump((8 - intersections[0].distance)/20)
            velocity.y = 0;
        }
        moveJump( velocity.y * delta );
    })
    return null
}

const euler = new THREE.Euler(0, 0, 0, 'YXZ');
let first = true;

function LookControls({ enabled }) {
  const { camera, gl } = useThree()
  useEffect(() => {
    if(!first) return;
    first = false;
    
    const state = {
      drag: false,
      prev: { screenX: null, screenY: null },
    }
    gl.domElement.style.cursor = 'grab'
    const onMouseDown = (e) => {
      state.drag = true
      e.target.style.cursor = 'grabbing'
      state.prev.screenX = e.screenX
      state.prev.screenY = e.screenY
    }
    const onMouseUp = () => {
      state.drag = false
      gl.domElement.style.cursor = 'grab'
    }
    const onMouseMove = (e) => {
      if (state.drag) {
        const dx = e.screenX - state.prev.screenX
        const dy = e.screenY - state.prev.screenY
        euler.setFromQuaternion(camera.quaternion)
        euler.y -= dx * 0.002
        euler.x -= dy * 0.002
        camera.quaternion.setFromEuler(euler)
      }
      state.prev.screenX = e.screenX
      state.prev.screenY = e.screenY
    }
    gl.domElement.addEventListener('mousemove', onMouseMove)
    gl.domElement.addEventListener('mousedown', onMouseDown)
    gl.domElement.addEventListener('mouseup', onMouseUp)
  }, [camera, gl]);

  return null
}


export { WasdControls, LookControls  };